import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export const SignInButton = () => {
  const { instance } = useMsal();

  return (
    <button
      onClick={() => instance.loginRedirect(loginRequest)}
      className="bg-white text-wmp-500 font-semibold py-2 px-5 rounded-lg
                       hover:bg-wmp-100 transition-colors duration-200
                       focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-wmp-500
                       text-sm shadow-sm"
    >
      Sign In
    </button>
  );
};
